import React, {FC, useState} from 'react';
import FontBody1 from '../../../../../components/fonts/font-body1/font-body1';
import {FONT_COLOR, FONT_VARIANT} from '../../../../../components/fonts/font-props';
import Card from '../../../../../components/layouts/card/card';
import customizationStore from '../../../../../stores/customizations/customization-store';
import {FormField} from '../../../../../components/form-field/form-field';
import {ISOLATION_MODE} from '../../../../../models/User';
import ListLayout from '../../../../../components/layouts/list-layout/list-layout';
import {FormFieldLine} from '../../../../../components/form-field-line/form-field-line';
import {Toggle} from '../../../../../components/inputs/toggle/toggle';
import {Textarea} from '../../../../../components/inputs/textarea/textarea';
import {Note, NOTE_TYPE} from '../../../../../components/note/note';
import FontBody2 from '../../../../../components/fonts/font-body2/font-body2';
import currentPortalStore from '../../../../../stores/current-portal-store';
import {observer} from 'mobx-react';
import {Input} from '../../../../../components/inputs/input/input';


const AdvancedCard: FC = observer(() => {

	const [isExpanded, setIsExpanded] = useState(false);
	const activeCustomizationStore = customizationStore.getSelectedStore();
	const classicCustomizationStore = customizationStore.getClassicStore();

	const portalIsolated = currentPortalStore.setting?.portalIsolationMode === ISOLATION_MODE.SHADOW_DOM;
	const togglePortalIsolated = (v: boolean) => {
		const newVal = portalIsolated ? ISOLATION_MODE.NONE : ISOLATION_MODE.SHADOW_DOM;
		currentPortalStore.setting?.setPortalIsolationMode(newVal);
	};

	return (
		<Card
			toolbar={{
				title: <FontBody1 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>Advanced</FontBody1>
			}}
			isExpanded={isExpanded}
			expandCallback={setIsExpanded}
		>
			<FormField
				label=""
				instructions="Configure additional features and settings to customize your portal’s look and feel."
				children={null}
			/>
			<ListLayout>
				<FormFieldLine
					label='Minimal top offset'
					tooltip={
						<FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>Minimal top offset in % to scroll to embedded version of return portal</FontBody2>
					}
				>
					<Input type="number" value={classicCustomizationStore.minEmbeddedOffsetTop} onChange={classicCustomizationStore.setMinEmbeddedOffsetTop} adornment="%"/>
				</FormFieldLine>

				<FormFieldLine
					label="Isolated Portal"
					note="Render your portal in an isolated mode to prevent styling conflicts between the portal and any custom styling your store may have."
				>
					<Toggle label="" checked={portalIsolated} onChange={togglePortalIsolated}/>
				</FormFieldLine>

				{portalIsolated &&
            <FormField
                label="Custom CSS"
                instructions={
									(<p>
										Add custom CSS code to further customize your portals. &nbsp;
										<a href="https://support.returngo.ai/advanced-styling-customization#Styling" target="_blank"
										   rel="noreferrer">Learn More</a>
									</p>)
								}
            >
                <Textarea
                    value={activeCustomizationStore.portalCss}
                    onChange={activeCustomizationStore.setPortalCss}
                    placeholder={'Enter your custom CSS here'}
                />
            </FormField>
				}

				<Note
					type={NOTE_TYPE.INFORMATION}
					body={
						<FontBody2>
							For more information about advanced styling and portal embedding options, <a
							href="https://support.returngo.ai/advanced-styling-customization" target="_blank" rel="noreferrer">
							check out the documentation and examples</a>
						</FontBody2>
					}
				/>
			</ListLayout>
		</Card>
	);
});

export default AdvancedCard;
